import { createContext, useState } from 'react';
import api from 'services/api';

export const GarantiaContext = createContext();

export const GarantiaProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [garantia, setGarantia] = useState({
    data: [],
    colunas: [],
    order: { field: 'dtemissao', sort: 'desc' },
    filter: {},
    page: 0,
    size: 10,
  });

  const getGarantia = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: garantia?.filter,
        page: garantia?.page,
        size: garantia?.size,
        order: garantia?.order,
        ...payload,
      });
      setGarantia((prev) => ({ ...prev, ...data, ...payload }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <GarantiaContext.Provider
      value={{
        garantia,
        getLoading,
        getGarantia,
      }}
    >
      {children}
    </GarantiaContext.Provider>
  );
};
